<template>
  <div class="home-layout">
    <AppHeader />
    <main class="home-main">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'HomeLayout',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<script setup>
</script>

<style lang="scss" scoped>
.home-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.home-main {
  flex: 1;
  margin-top: 0;
}

// 响应式设计
@media (max-width: 1000px) {
  .home-main {
    margin-top: 60px;
  }
}
</style>